import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { onError } from 'apollo-link-error';
import { isObject } from 'lodash';

import config from '@/config';
import ApolloClientException from '@/exceptions/ApolloClientException';

const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  if (graphQLErrors) {
    const { operationName, variables } = operation;
    // eslint-disable-next-line no-restricted-syntax
    for (const err of graphQLErrors) {
      const { message, extensions: { code, path } } = err;
      if (window.appInsights) {
        window.appInsights.trackException({
          exception: new ApolloClientException(message),
          severityLevel: 4,
          properties: {
            operationName,
            variables: variables && isObject(variables) ? JSON.stringify(variables) : JSON.stringify({}),
            code,
            path,
          },
        });
        window.appInsights.flush();
      }
    }
  }

  if (networkError) {
    window.console.log(`[Network error]: ${networkError}`);
  }
});

const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri: config.ENDPOINTS.CAT4MRO,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = window.localStorage.getItem('auth:token');
  // TODO: window.localStore.getItem('auth:headers');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const cache = new InMemoryCache({
  dataIdFromObject: o => o.id,
});

const link = ApolloLink.from([
  authLink,
  errorLink,
  httpLink,
]);

// Create the apollo client
export const apolloClient = new ApolloClient({
  link,
  cache,
  connectToDevTools: true,
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

export default ({ app, Vue }) => {
  Vue.use(VueApollo);
  Vue.set(app, 'apolloProvider', apolloProvider);
};



// WEBPACK FOOTER //
// ./src/plugins/vue-apollo.js